export default {
  TEST_ID: "event-switcher-card",
  PLACEHOLDER_TEST_ID: "event-switcher-card-placeholder",
  THEMING_IMAGE: "event-switcher-card-theming",
};
